import React from 'react';

import { EmptyState } from '@ergeon/core-components';
import { CursorArrowRaysIcon } from '@ergeon/icons/hero/outline';

export const NoCallSelectedEmptyState = () => (
  <div className="flex flex-col flex-grow justify-center items-center p-12 w-full">
    <EmptyState
      description="Select a call from the left sidebar to see its details."
      icon={<CursorArrowRaysIcon />}
      title="No call selected" />
  </div>
);
